import { Button, useTheme } from '@mui/material';
import { ReactNode } from 'react';
import { MethodButtonStyles } from './styles';

interface MethodButtonProps {
  children: ReactNode;
  isSelected?: boolean;
  onClick?: () => void;
}

export default function MethodButton({ children, isSelected, onClick }: MethodButtonProps) {
  const theme = useTheme();
  const styles = MethodButtonStyles(theme, isSelected ?? false);
  return (
    <Button variant="outlined" onClick={onClick} sx={styles.mainContainer}>
      {children}
    </Button>
  );
}
